import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { listenToMessage } from './service/jiraOPService';

listenToMessage();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
